import React from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../ui/table";
import { Button } from "../ui/button";
import { ScoreBadge, StatusPill } from "../Badges";
import { STAGES, eur, probColor } from "../../lib/constants";
import { Sparkles, ArrowUpDown } from "lucide-react";

const STAGE_COLOR = Object.fromEntries(STAGES.map((s) => [s.key, s.color]));

export const ProspectTable = ({ rows, onOpen, onToggleSort, onQuickAnalyze }) => (
  <div className="overflow-hidden rounded-xl border border-border bg-card">
    <Table>
      <TableHeader>
        <TableRow className="border-border hover:bg-transparent">
          <TableHead className="w-8"></TableHead>
          <TableHead>Azienda</TableHead>
          <TableHead>Settore</TableHead>
          <TableHead>Città</TableHead>
          <TableHead className="cursor-pointer select-none" onClick={onToggleSort}>
            <span className="inline-flex items-center gap-1">Score <ArrowUpDown className="h-3 w-3" /></span>
          </TableHead>
          <TableHead>Acq.</TableHead>
          <TableHead>Servizio</TableHead>
          <TableHead>Stato</TableHead>
          <TableHead className="text-right">Valore</TableHead>
          <TableHead></TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {rows.map((p) => <ProspectRow key={p.id} p={p} onOpen={onOpen} onQuickAnalyze={onQuickAnalyze} />)}
        {rows.length === 0 && (
          <TableRow><TableCell colSpan={10} className="py-12 text-center text-muted-foreground">
            Nessun prospect. Aggiungine uno o importa un CSV.
          </TableCell></TableRow>
        )}
      </TableBody>
    </Table>
  </div>
);

function ProspectRow({ p, onOpen, onQuickAnalyze }) {
  const prob = p.acquisition?.probability;
  return (
    <TableRow onClick={() => onOpen(p)} className="cursor-pointer border-border" data-testid={`row-${p.id}`}>
      <TableCell><span className="text-lg" style={{ color: STAGE_COLOR[p.status] }}>•</span></TableCell>
      <TableCell className="font-medium">
        {p.azienda}
        {p.referente && <div className="text-xs text-muted-foreground">{p.referente}</div>}
      </TableCell>
      <TableCell className="text-sm text-muted-foreground">{p.settore || "—"}</TableCell>
      <TableCell className="text-sm text-muted-foreground">{p.citta || "—"}</TableCell>
      <TableCell><ScoreBadge score={p.score} priority={p.priority} size="sm" /></TableCell>
      <TableCell className="text-sm font-semibold tabular-nums">
        {prob != null ? <span style={{ color: probColor(prob) }}>{prob}%</span> : <span className="text-muted-foreground">—</span>}
      </TableCell>
      <TableCell className="text-sm">{p.servizio_consigliato || <span className="text-muted-foreground">—</span>}</TableCell>
      <TableCell><StatusPill status={p.status} /></TableCell>
      <TableCell className="text-right text-sm tabular-nums">{p.valore_potenziale ? eur(p.valore_potenziale) : "—"}</TableCell>
      <TableCell>
        {!p.ai_analyzed && (
          <Button size="icon" variant="ghost" onClick={(e) => onQuickAnalyze(e, p.id)} data-testid={`analyze-row-${p.id}`} title="Analizza con AI">
            <Sparkles className="h-4 w-4 text-primary" />
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
}
